import React from "react";
import styles from "./ProfileStore.module.css";
import Booster from "../../Boosters/Booster";
import { boosterData } from "../../../services/BoosterServices";
import FilterBoosters from "../../Boosters/FilterBoosters/FilterBoosters";
import InfiniteScroll from "../../InfiniteScroll/InfiniteScroll";
import { useFetchedUserBoostersContext } from "../../../context/fetchedUser/FetchedUserBoostersProvider";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ProfileStore: React.FC = () => {
  const oneWeekAgo = new Date();
  const { boostersState } = useFetchedUserBoostersContext();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 2);
  const { t } = useTranslation();

  return (
    <>
      <InfiniteScroll
        togglePage={boostersState.togglePage}
        loading={boostersState.loading}
        hasMore={boostersState.hasMore}
      >
        <FilterBoosters
          boosters={boostersState.data}
          handleFilterBoosters={boostersState.setFilteredData}
        />
        {boostersState.filteredData.length > 0 ? (
          <div className={styles.container}>
            {boostersState.filteredData
              .filter((booster) => booster.is_in_store)
              .map((booster: boosterData) => (
                <div className={styles.boosterContainer}>
                  <Link to={`/boosters/${booster.id}`} className={styles.unset}>
                    <Booster
                      booster={booster}
                      key={booster.id}
                      isInStore={true}
                    />
                    <div className={styles.cardInfo}>
                      <div>{booster.name}</div>
                      <strong>{booster.price}€</strong>
                    </div>
                  </Link>
                </div>
              ))}
          </div>
        ) : (
          <h2 className={styles.center}>{t("noContent")}</h2>
        )}
      </InfiniteScroll>
    </>
  );
};

export default ProfileStore;
